/**
 * The slug a public page is reached by, matching the one the public views
 * build from a title. Kept in one place so the dashboard's "live at" links
 * cannot drift from where the page actually is.
 */

// The combining-mark range is built from char codes rather than written as an
// escape in a regex literal: tooling in this project keeps folding the escape
// into the raw characters, which are invisible in an editor and easy to break.
const COMBINING_MARKS = new RegExp(
  '[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']',
  'g'
);

export default function slugify(str) {
  try {
    return (str || '')
      .normalize('NFD')
      .replace(COMBINING_MARKS, '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  } catch {
    return '';
  }
}
